<template>
  <v-container fluid style="max-width: 99% !important;padding-bottom: 125px;">
    <v-row>
      <v-row style="display: contents;">
        <template v-for="(item, index) in data">
          <v-col
            cols="12"
            lg="2"
            md="4"
            sm="6"
            xs="12"
            style="text-align: initial; line-height: normal;min-width: 130px;"
            v-bind:key="index"
          >
            <v-card height="135px" style="display: grid;" :color="whitesmoke">
              <v-row style="display: contents;">
                <v-divider
                  light
                  vertical
                  :color="colorTheme"
                  style="position: absolute;border-width: 2px;"
                ></v-divider>
                <v-col cols="12">
                  <div class="regularText">{{ item.title }}</div>
                </v-col>
                <v-col cols="12">
                  <div
                    class="cardValueText font-weight-medium my-2"
                  >{{ item.value }}</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </template>
      </v-row>
      <v-row style="display: contents;">
        <v-col cols="12">
          <v-card>
            <v-card-title class="subtitle3Text">
              {{
              $t("categories").toUpperCase()
              }}
            </v-card-title>
            <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
            <v-card-text>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col sm="12" lg="6" md="6" cols="12">
                    <v-row
                      align="center"
                      justify="center"
                      style="color: black;font-size: 18px;"
                    >{{ $t("driving") }}</v-row>
                    <v-row align="center" justify="center">
                      <div id="container1" :style="sizeChart1"></div>
                    </v-row>
                  </v-col>
                  <v-col sm="12" lg="6" md="6" cols="12">
                    <v-row
                      align="center"
                      justify="center"
                      style="color: black;font-size: 18px;"
                    >{{ $t("operation") }}</v-row>
                    <v-row align="center" justify="center">
                      <div id="container2" :style="sizeChart2"></div>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row align="center" justify="center">
                  <v-col sm="12" lg="6" md="6" cols="12">
                    <v-row
                      align="center"
                      justify="center"
                      style="color: black;font-size: 18px;"
                    >{{ $t("logistics") }}</v-row>
                    <v-row align="center" justify="center">
                      <div id="container3" style="width: 100%;height:400px;"></div>
                    </v-row>
                  </v-col>
                  <v-col sm="12" lg="6" md="6" cols="12">
                    <v-row
                      align="center"
                      justify="center"
                      style="color: black;font-size: 18px;"
                    >{{ $t("diagnosticUnit") }}</v-row>
                    <v-row align="center" justify="center">
                      <div id="container4" style="width: 100%;height:400px;"></div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";
import { Chart } from "highcharts-vue";
export default {
  data() {
    return {
      itemsExceptions: [],
      itemsDashboardInfo: [],
      incidents: "",
      vehicles: "",
      data: []
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setPageHeader", [
      this.$t("dashboard"),
      this.$t("exceptions"),
      "",
      "",
      false
    ]);
  },
  components: {
    highcharts: Chart
  },
  computed: {
    ...mapState([
      "ItemsDashboard",
      "whitesmoke",
      "backgroundSkeleton",
      "fontsizecard",
      "colorTheme",
      "sizeChart1",
      "sizeChart2"
    ])
  },
  mounted() {
    this.setData();
    this.createChart();
  },
  methods: {
    setData() {
      this.itemsDashboardInfo = JSON.parse(
        localStorage.getItem("ItemsDashboard")
      );
      //console.log(this.itemsDashboardInfo);
      this.vehicles = localStorage.getItem("vehicles");
      this.incidents = this.itemsDashboardInfo.IntransitIncidents.Total;
      this.data = [
        { title: i18n.t("vehiclesD"), value: this.vehicles },
        { title: i18n.t("exceptionsHome"), value: this.incidents }
      ];
    },
    createChart() {
      // Create the chart
      var inTransit = this.itemsDashboardInfo.IntransitIncidents.Categories;
      // console.log(inTransit);
      this.$store.dispatch("createPieCharts", [
        "container1",
        inTransit.DRIVING
      ]);
      this.$store.dispatch("createPieCharts", [
        "container2",
        inTransit.OPERATION
      ]);
      this.$store.dispatch("createPieCharts", [
        "container3",
        inTransit.LOGISTICS
      ]);
      this.$store.dispatch("createPieCharts", [
        "container4",
        inTransit.DIAGNOSTICS
      ]);
    }
  }
};
</script>
